export const supportEmail = "support@aletheamedical.com";
export const defaultPage = "/dashboard/messages";
export const createProfilePage = "/signup/create-profile";